// extracted by mini-css-extract-plugin
export default {"ingredientsdirection":"alcoholselector_ingredientsdirection__gBvI4"};